var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlacklistAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,511.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1260.1,4993.6c-90-26-218.1-160.1-244.1-254.1c-14-56-18-1480.8-16-4668.7l6-4590.6l48-76c26-42,84.1-100.1,128.1-130.1l82-54l2371.4-6l2373.4-4l1496.8,1496.9l1494.9,1494.9l-4,3273.9l-6,3271.9l-54,82.1c-30,44-88,102.1-130.1,128.1l-76,48l-3702.1,4C2728.9,5011.6,1302.1,5005.6,1260.1,4993.6z M5704.6,3530.8l704.4,704.4l356.2-354.2l354.2-356.2L6415,2820.4L5708.7,2114l706.4-706.4l704.4-704.4L6765.3,347L6409.1-7.2l-704.4,704.4l-706.4,706.4l-706.4-706.4L3587.4-7.2L3231.2,347L2877,703.2l704.4,704.4l706.4,706.4l-706.4,706.4L2877,3524.8l354.2,356.2l356.2,354.2l704.4-704.4l706.4-706.4L5704.6,3530.8z M7359.6-3139L6208.9-4289.7l-6,1064.6c-4,770.4,2,1082.6,18,1122.6c48,114.1,32,112.1,1208.7,114.1h1080.6L7359.6-3139z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklistAdd);
export default __webpack_public_path__ + "static/media/blacklist-add.9b22b01f.svg";
export { ForwardRef as ReactComponent };